// services.js — Bootstrap "architecture propre" (client + services).
// Chargé tôt via main.js AVANT app.js & cloudDeckImport.js.

import { createSupabaseClient } from "./infra/supabaseClient.js";
import * as auth from "./auth/authService.js";
import * as decks from "./data/deckService.js";

const CONFIG_KEY = "bulle::config";
const CONFIG_DEFAULT = {
  supabaseUrl: "https://tsasdqexdvieojuzthms.supabase.co",
  supabaseAnonKey: "sb_publishable_aFCY9wDc03wFy1iBQjqcdg__PACewCD",
  channelPrefix: "room:bulle:",
  longPressMs: 650
};

function safeGet(k){
  try{ return window.localStorage ? window.localStorage.getItem(k) : null; }catch(_e){ return null; }
}
function safeSet(k,v){
  try{ if(window.localStorage) window.localStorage.setItem(k,v); }catch(_e){}
}

export function loadConfig(){
  try{
    const raw = safeGet(CONFIG_KEY);
    if(!raw) return { ...CONFIG_DEFAULT };
    const p = JSON.parse(raw);
    return {
      ...CONFIG_DEFAULT,
      supabaseUrl: typeof p.supabaseUrl === "string" ? p.supabaseUrl : CONFIG_DEFAULT.supabaseUrl,
      supabaseAnonKey: typeof p.supabaseAnonKey === "string" ? p.supabaseAnonKey : CONFIG_DEFAULT.supabaseAnonKey,
      channelPrefix: typeof p.channelPrefix === "string" ? p.channelPrefix : CONFIG_DEFAULT.channelPrefix,
      longPressMs: Number.isFinite(p.longPressMs) ? p.longPressMs : CONFIG_DEFAULT.longPressMs
    };
  }catch(_e){
    return { ...CONFIG_DEFAULT };
  }
}

export function ensureConfigStored(){
  const raw = safeGet(CONFIG_KEY);
  if(!raw){
    safeSet(CONFIG_KEY, JSON.stringify(CONFIG_DEFAULT));
  }
}

export function initServices(){
  ensureConfigStored();
  const cfg = loadConfig();
  createSupabaseClient({ url: cfg.supabaseUrl, anonKey: cfg.supabaseAnonKey });

  // Expose minimal global API for legacy parts of the game
  try{
    window.BulleServices = {
      config: cfg,
      supabase: {
        getClient: () => window.__bulleSupabaseClient
      },
      auth,
      decks
    };
  }catch(_e){}
}

// Auto-init at import time
initServices();
